

































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import {
  SwatchCMSSearchOptions,
  PageConfig,
  PRODUCT_CATEGORY_ID
} from "../../types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
export default Vue.extend({
  name: "search-projects",
  data() {
    return {
      search: {
        placeholder:
          "Search by item name, brand, product code, display name,etc.",
        buttonText: "Search",
        isDropdownAvailable: true,
        dropdownOptions: SwatchCMSSearchOptions,
        dropdownSelected: {} as { name: string; display_name: string },
        searchText: ""
      }
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc"
    })
  },
  methods: {
    onProductSearch(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      if (searchData && searchData.option && searchData.searchText !== "") {
        this.search.searchText = searchData.searchText;
        this.searchProduct(searchData);
      }
    },
    searchProduct(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      let searchFilter = {},
        pageConfig = JSON.parse(JSON.stringify(PageConfig));
      switch (searchData.option.name) {
        case "product_code":
          searchFilter = {
            code: searchData.searchText
          };
          break;
        case "brand":
        case "display_name":
        case "sku_code":
          searchFilter = {
            term: searchData.searchText
          };
          break;
      }
      //always search for items having EC_Collaterals as category - PRODUCT_CATEGORY_ID
      searchFilter = Object.assign(
        {},
        { product_category_id: PRODUCT_CATEGORY_ID },
        searchFilter
      );
      const query = {
        filters: searchFilter,
        start: PageConfig.offset,
        count: PageConfig.limit
      };
      pageConfig.query = encodeQueryParams(query);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/add/" +
        JSON.stringify({
          filters: searchFilter,
          search: searchData,
          pageConfig: pageConfig
        });
      this.$router.push({
        path: routeLink
      });
    },
    handleUpdateRoute(routeData: {
      to: string;
      data: { sku_code: string; sku_name: any };
    }) {
      let urlQuery;
      if (routeData.to === "finish") {
        //format and store the selected product
        this.$store.commit(
          "appModule/setSelectedSearchProduct",
          routeData.data
        );
        urlQuery = "/add/" + routeData.data.sku_code + "/finishes";
      } else if (routeData.to === "add") {
        urlQuery = "/add";
      }
      this.$router.push({ path: "/" + this.selectedEc.name + urlQuery });
    }
  },
  created() {
    //based on the route params update the searchbar props
    if (this.$router.currentRoute.params.searchQuery) {
      const paramsJSON = JSON.parse(
        this.$router.currentRoute.params.searchQuery
      );
      this.search.searchText = paramsJSON.search.searchText;
      this.search.dropdownSelected = paramsJSON.search.option;
    } else {
      this.search.searchText = "";
      this.search.dropdownSelected = this.search.dropdownOptions[0];
    }
  }
});
